import React from 'react';
import { Button, Table, Form, Popup } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const fetchStaff = (courseImplementationId) => axios.get(`/course/implementation/staff/${courseImplementationId}`);
const fetchExamStaff = (gradedActivityId) => axios.get(`exams/staff/${gradedActivityId}`);

const NoDataMessage = () => <p>Nema uposlenika.</p>;

export default class ExamStaff extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            courseStaff: [],
            staffArray: [],
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.addStaff = this.addStaff.bind(this);
        this.fetchStaff = this.fetchStaff.bind(this);
        this.removeStaff = this.removeStaff.bind(this);
    }
    componentDidMount() {
        this.fetchStaff();
    }

    fetchStaff() {
        axios.all([fetchStaff(this.props.courseImplementationId), fetchExamStaff(this.props.gradedActivityId)])
            .then(axios.spread((staffRes, dataRes) => {
                const courseStaff = staffRes.data.map(el => ({
                    ...el, text: el.employee.person.firstName + ' ' + el.employee.person.lastName + ' - ' + el.courseRoleType.name, value: el.id, key: el.id
                }));

                this.setState({
                    courseStaff,
                    data: dataRes.data
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch data...');
            });
    }

    handleInputChange(event, { name, value }) {
        console.log('value', value[0]);
        console.log('this.state.data', this.state.data);
        console.log('this.state.data.find(el => el.staff.id === value)', this.state.data.filter(el => el.staff.id === value[0]).length);
        if (this.state.data.filter(el => el.staff.id === value[0]).length) {
            toast('Profesor je već na ispitu!');
        } else {
            this.setState({
                [name]: value
            });
        }
    }

    addStaff() {
        const staffArray = this.state.staffArray;
        axios.post(`exams/add-staff/${this.props.gradedActivityId}`, [...staffArray])
            .then(res => {
                toast('Uspješno ste dodali nastavno osoblje na ispit.');
                this.fetchStaff();
                this.setState({ staffArray: [] });
            })
            .catch(err => {
                toast('Došlo je greške! Nastavno osoblje nije dodano na ispit.');
            });
    }

    removeStaff(id) {
        let list = [id];
        axios.delete('exams/remove-staff', { data: list })
            .then(res => {
                toast('Uspješno ste uklonili nastavno osoblje sa ispita.');
                this.fetchStaff();
            })
            .catch(err => {
                if (err.response.data === 'Staff is on sga!') {
                    toast('Ispit već ima prijavljene studente kod navedenog profesora. Nije moguće ukloniti osoblje.');
                } else {
                    toast('Došlo je greške! Nastavno osoblje nije uklonjeno sa ispita.');
                }
            });
    }


    render() {
        return (
            <div>
                {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') &&<Form>
                    <Form.Group widths="equal">

                        <Form.Field>
                            <label>Odabir nastavnog osoblja</label>
                            <Form.Dropdown
                                clearable
                                multiple
                                selection
                                placeholder="Odaberite osoblje"
                                value={this.state.staffArray}
                                onChange={this.handleInputChange}
                                name="staffArray"
                                options={this.state.courseStaff}
                                search
                                fluid
                            />
                        </Form.Field>
                        <Form.Button color="blue" label=" " /*disabled={localStorage.getItem('finalized')}*/ onClick={this.addStaff}>Dodaj nastavno osoblje na ispit</Form.Button>

                    </Form.Group>

                </Form>}
                <br />
                {this.state.data ?

                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>
                                    Prezime i ime
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Uloga na predmetu
                                </Table.HeaderCell>
                                {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') &&<Table.HeaderCell width="2">
                                </Table.HeaderCell>}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.state.data.map(el =>
                            (<Table.Row key={el.staff.employee.id} >
                                <Table.Cell verticalAlign="middle">
                                    {el.staff.employee.person.lastName} {el.staff.employee.person.firstName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.staff.courseRoleType.name}
                                </Table.Cell>
                                {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') &&<Table.Cell textAlign="center" verticalAlign="middle" width="2">
                                    <Popup
                                        content="Ukloni sa ispita"
                                        position="top center"
                                        trigger={
                                            <Button
                                                /*disabled={localStorage.getItem('finalized')}*/
                                                basic="true"
                                                circular
                                                icon="user times"
                                                size="small"
                                                color="red"
                                                onClick={() => {
                                                    if (this.state.data.length === 1) { toast('Ispit mora imati barem jednog profesora. Dodajte novog prije brisanja.'); } else this.removeStaff(el.id);
                                                }}
                                            />}
                                    />
                                </Table.Cell>}
                            </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                    : <NoDataMessage />
                }

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/ExamStaff.js